import { setCurrentPage } from "../../reducers/navigation"
import { LOAD_LOCAL_VSLA_MEMBERS } from "./getVslaMembers"
import { triggerAction } from "../../constants"
import { safeApiCall } from "../../api/offline"
import { checkOnlineStatus, db } from "../../../view/shared/utilities/cache"

export function createMember(data, isExisting = false) {
  return async function (dispatch, getState) {
    const isOnline = await checkOnlineStatus()
    const { group, user } = getState()
    const group_id = group?.id
    const isTempGroup = group?.syncStatus && group.syncStatus !== "synced"
    const cacheKey = data.pubkey
    let needBodyUpdate = null
    const newMemberUrlSeg = `members?request_id=${cacheKey}`
    const existingMemberUrlSeg = `existing-members?request_id=${cacheKey}`
    let url = `${window.REACT_APP_PWA_APP_DOMAIN}/groups-hedera/${
      isTempGroup ? "{{group}}" : group_id
    }`
    if (isExisting) {
      url = `${url}/${existingMemberUrlSeg}`
      needBodyUpdate = isTempGroup
        ? {
            secretary_id: "group",
          }
        : null
    } else {
      url = `${url}/${newMemberUrlSeg}`
    }
    const headers = { Authorization: `Bearer ${user.token}` }
    const offlineRequests = await db.offlineRequests.toArray()
    const localMembers = offlineRequests.filter(
      ({ userId, entityType }) => userId === user?.id && entityType === "members",
    )
    const optimisticMemberData = {
      ...data,
      syncStatus: isOnline ? "processing" : "pending",
      error: null,
      cacheId: cacheKey,
    }

    const config = {
      type: "WEBSOCKET_ACTION",
      pushEvent: "requests",
      receiveEvent: "response",
      emit: true,
      protocol: "ws",
      userId: user?.id,
      tempId: cacheKey,
      entityType: "members",
      dependsOn: isTempGroup ? "group" : null,
      needBodyUpdate,
      optimisticActions: [
        triggerAction(LOAD_LOCAL_VSLA_MEMBERS, [
          optimisticMemberData,
          ...localMembers.map((m) => ({
            ...m.payload.data,
            cacheId: m.cacheId,
            syncStatus: m.status,
            error: m.error || null,
          })),
        ]),
      ],
      metadata: {
        type: "members",
      },
      payload: {
        requestId: cacheKey,
        url,
        headers,
        data: data,
        userId: user?.id,
        method: "POST",
      },
    }

    dispatch(setCurrentPage("group-memberList"))
    return safeApiCall(config)
  }
}
